import ObjectMapController from "./object_map_controller"

export default class ExchangeDealsMapController extends ObjectMapController {
  static values = {
    ...ObjectMapController.values,
    subjectType: "deal",
  }
}
